<div class="schedule-navbar">
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content">
        <p class="large">Week {{ beginDate | date: 'YYYY - w' }}</p>
        <p class="small">{{ beginDate | date: 'dd-MMM' }} - {{ endDate | date: 'dd-MMM' }}</p>
    </div>
    <div>
        <button (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="week-check-realisations-check first d-print-none">
    <div class="header">
        <div class="container-xl">
            <div class="content row">
                <div class="col d-flex justify-content-center">
                    @if (userFunctions) {
                        <mat-form-field appearance="outline">
                            <mat-label>Filter op functie</mat-label>
                            <mat-select [formControl]="fcUserFunction" multiple>
                                @for (userFunction of userFunctions; track userFunction) {
                                    <mat-option [value]="userFunction">
                                        {{ userFunction }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
                <div class="col d-flex justify-content-center">
                    @if (userFunctions) {
                        <mat-form-field appearance="outline">
                            <mat-label>Sortering</mat-label>
                            <mat-select [formControl]="fcSort">
                                <mat-option value="name"> Naam </mat-option>
                                <mat-option value="hours"> Uren </mat-option>
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<div class="week-check-realisations-check first last">
    @if (show) {
        <div class="list">
            @for (user of users; track user; let even = $even) {
                <div class="list-item" [class.warn]="!even">
                    <div class="container-fluid">
                        <div class="content">
                            <div class="name-wrapper">
                                <div class="name">
                                    {{ user.name }}
                                </div>
                                <div class="caption">
                                    {{ user.function }}
                                </div>
                            </div>
                            <div class="times">
                                <div class="time" [class.downlight]="userTotal.get(user.id) < 1">
                                    <div>
                                        @if (userTotal.has(user.id)) {
                                            <span>{{ userTotal.get(user.id) | minutes }}</span>
                                        }
                                        @if (!userTotal.has(user.id)) {
                                            <i class="fa fa-loader fa-spin"></i>
                                        }
                                    </div>
                                </div>
                                @for (loopdate of loopDates; track loopdate) {
                                    <div
                                        class="time"
                                        [class.downlight]="
                                            userRealisationMap.get((loopdate | date: 'yyyy-MM-dd') + user.id)
                                                ?.totaltime < 1
                                        "
                                        [class.approved]="
                                            !userRealisationMap.get((loopdate | date: 'yyyy-MM-dd') + user.id)
                                                ?.anyUnapproved
                                        "
                                        (dblclick)="editHours(loopdate, user.id)">
                                        <div
                                            [class.night]="
                                                userRealisationMap.get((loopdate | date: 'yyyy-MM-dd') + user.id)
                                                    ?.isNight
                                            ">
                                            <span class="prepend">{{ loopdate | date: 'EEE' }}</span>
                                            <span>{{
                                                userRealisationMap.get((loopdate | date: 'yyyy-MM-dd') + user.id)
                                                    ?.totaltime | minutes
                                            }}</span>
                                        </div>
                                        <small>{{
                                            userRealisationMap.get((loopdate | date: 'yyyy-MM-dd') + user.id)?.projects
                                                | joinBy
                                        }}</small>
                                    </div>
                                }
                            </div>
                            <div class="buttons d-print-none">
                                <button
                                    class="planning-button"
                                    (click)="editHours(beginDate, user.id)"
                                    mat-icon-button
                                    color="primary">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</div>

<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            <button
                class="planning-button"
                mat-raised-button
                color="accent"
                routerLink="/dagcontrole/{{ beginDate | date: 'yyyy-MM-dd' }}">
                Dagcontrole
            </button>
            <div class="settings-menu">
                <app-settings-menu [date]="beginDate"></app-settings-menu>
            </div>
            <button
                class="planning-button"
                mat-raised-button
                color="primary"
                routerLink="/check-hours/{{ beginDate | date: 'yyyy-MM-dd' }}">
                Urencontrole
            </button>
        </div>
    </div>
</div>
